var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiGraphLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6667 35.8308L61.5633 13.5354L66.8254 16.5771L50.9175 44.1042L31.1162 32.6979L16.6075 57.7917H66.9167V63.875H6.08333V9.125H12.1667V53.3508L28.8958 24.3333L48.6667 35.8308Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiGraphLine);
export default __webpack_public_path__ + "static/media/mdi_graph-line.9c118b0d02e5b2b3ec19ec2dab5de3dc.svg";
export { ForwardRef as ReactComponent };